var map = {
	"./Loading-Icon.gif": 1148,
	"./app-awareness-phone.png": 578,
	"./app-modal-android@2x.png": 579,
	"./app-modal-iphone@2x.png": 580,
	"./app-promo-banner-background.png": 1149,
	"./box-prices/2-portions.png": 1150,
	"./box-prices/2-portions.webp": 1151,
	"./box-prices/4-portions.png": 1152,
	"./box-prices/4-portions.webp": 1153,
	"./box-prices/best-value.png": 581,
	"./box-prices/box-prices-hero.jpg": 696,
	"./box-prices/couples-box.jpg": 1154,
	"./box-prices/family-box.jpg": 1155,
	"./box-prices/four-person-box.jpg": 576,
	"./box-prices/most-popular.png": 582,
	"./box-prices/two-person-box.jpg": 575,
	"./discount-modal-header.jpg": 583,
	"./earn-reward-background.jpg": 1156,
	"./five-recipes/five-recipes.png": 1157,
	"./gousto-boxes.jpg": 1158,
	"./gousto-welcome-journey-rollover.jpg": 1159,
	"./hungry-for-savings.png": 1160,
	"./menu/FebYouary_desktop.jpg": 1161,
	"./menu/FebYouary_mobile.jpg": 1162,
	"./menu/FebYouary_tablet.jpg": 1163,
	"./menu/default_desktop_no_click.png": 1164,
	"./menu/default_mobile_no_click.png": 1165,
	"./menu/default_tablet_no_click.png": 1166,
	"./menu/spottyTileBorder.png": 584,
	"./my-gousto-pricing-modal.svg": 1167,
	"./pause-osr-modal-bg.jpg": 1168,
	"./product-placeholder.png": 409,
	"./recipe-placeholder.png": 238,
	"./red-rice-pattern.png": 1169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 695;